import { swap, deref } from '@dbeining/react-atom';
export function dispatch(ctx, update) {
    swap(ctx.state, update);
}
export function readState(ctx, read) {
    const state = deref(ctx.state);
    return read(state);
}
//# sourceMappingURL=state.js.map